import events from 'APP_ROOT/data/events';
const fleetFeatures = buildFeatures => ({
    traffic: true,
    satellite: true,
    vehicle_popup: 'fleet',
    logo_url: buildFeatures.logo_url || 'raven-logo',
    show_service_plan: false,
    show_billing: buildFeatures.show_billing,
    show_invoices: true,
    show_history: true,
    show_help: true,
    media_view: true,
    media_request: true,
    historical_streaming: true,
    facial_recognition: buildFeatures.facial_recognition,
    integrations: buildFeatures.integrations,
    fleet_reports: true,
    geofence_limit: undefined,
    global_settings: Object.assign(
        buildFeatures.global_settings,
        {
            wifi_hotspot: process.env.REACT_APP_FEATURE_SET === 'telus' ? true : false // Telus fleet uses get WiFi b/c their billing supports it (it's more granular than ours atm(?))
        }
    )
});

const consumerFeatures = buildFeatures => ({
    traffic: false,
    satellite: false,
    vehicle_popup: 'old',
    logo_url: buildFeatures.logo_url || 'raven-logo',
    show_service_plan: true,
    show_billing: buildFeatures.show_billing,
    show_invoices: true,
    show_history: true,
    show_help: false, // RAV-556
    media_view: true,
    media_request: true,
    historical_streaming: false, // RAV-1402
    facial_recognition: false,
    integrations: false,
    fleet_reports: false,
    geofence_limit: 4,
    global_settings: Object.assign(
        buildFeatures.global_settings,
        {
            daily_reports: false,
            driver_alerts: {
                section_available: false,
                audio_notifications: false // default is true, but overridden by section_available
            },
            events: Object.assign(
                buildFeatures.global_settings.events,
                events.reduce((acc, e) => {
                        // only enable consumer events features if the build hasn't explicitly disabled them
                        acc[e.snakeName] = e.isConsumerFeature && (buildFeatures.global_settings.events[e.snakeName] !== false);
                        return acc;
                    }, {}),
                {
                    tailgating_detection: false,
                }
            )
        }
    )

});

const VIEWS = {
    FLEET_ADMIN: {
        priority: 1,
        name: 'FLEET_ADMIN',
        features: buildFeatures => fleetFeatures(buildFeatures)
    },
    FLEET: {
        priority: 2,
        name: 'FLEET',
        features: buildFeatures => fleetFeatures(buildFeatures)
    },
    FLEET_GPS_ONLY: {
        priority: 3,
        name: 'FLEET_GPS_ONLY',
        features: buildFeatures => fleetFeatures(buildFeatures)
    },
    CONSUMER: {
        priority: 4,
        name: 'CONSUMER',
        features: buildFeatures => consumerFeatures(buildFeatures)
    },
    default: {
        priority: 5,
        name: 'default',
        features: buildFeatures => consumerFeatures(buildFeatures)
    }
};

export const determineFeatures = (featuresBase, accountDetails, ravens, custom_flags) => {

    if (!ravens || !ravens.length) {
        const features = VIEWS.default.features(featuresBase);
        features.show_history = false; // no ravens means no history
        return features;
    }

    let accountFeatures = accountDetails?.features || [];
   
    let bestView = ravens.reduce((acc, r) => {
        const view = VIEWS[r.view] || VIEWS.default;
        return view.priority < acc.priority ? view : acc;
    }, VIEWS.default);

    let viewFeatures = bestView.features(featuresBase);

    // add account level overrides

    viewFeatures = {
        ...viewFeatures,
        has_beacons: accountFeatures.includes('beacons'), // does the account have any beacons at all
        facial_recognition_enabled: accountFeatures.includes('facial_recognition') // this is whether the account has enabled the feature in settings, not whether it's available for account
    };

    return Object.assign(featuresBase, viewFeatures);
}

